export default __webpack_public_path__ + "static/media/10.9d528371.svg";